<form (submit)="onSubmit()" class="step-form" [formGroup]="form" #stepForm>
  @if (headlineTextkey) {
    <div class="grid-x grid-margin-x headline-wrapper">
      <div class="cell small-12 large-offset-1 large-10"><hr></div>
      <div class="cell small-12 large-offset-1 large-10 text-center">
        <h1 [innerHTML]="headlineTextkey | translate"></h1>
      </div>
      <div class="cell small-12 large-offset-1 large-10"><hr></div>
    </div>
  }

  <div class="grid-x grid-margin-x">
    @if (hasHelp) {
      <div class="cell small-12 medium-5 large-4 medium-order-2 help-wrapper">
        <button type="button" class="help-toggle hide-for-medium" [attr.aria-label]="'arialabel.toggle.help' | translate" (click)="togglePageHelp()">{{(showPageHelp? 'step.help.toggle.close' : 'step.help.toggle.show') | translate}} <i [class]="showPageHelp? 'icon-x-circle' : 'icon-info'"></i></button>
        @if (helpTextkey) {
          <div class="callout lighter-gray step-help" [class.show]="showPageHelp">
            <div [innerHTML]="helpTextkey | translate"></div>
            @if (hasInlineHelp) {
              <button (click)="toggleInlineHelp()" class="show-for-medium"><i class="icon-help-circle"></i> {{'step.help.more' | translate}}</button>
            }
          </div>
        }
      </div>
    }
    <div class="cell small-12 medium-7 large-offset-2 large-5 medium-order-1">
      @if (formError) {
        <div role="alert" class="form-errors">
          <p [innerHTML]="textkeyPrefix + '.step.error.' + formError | translate: {fallback: 'step.error.' + formError}"></p>
        </div>
      }
      @if (formWarning) {
        <div role="alert" class="form-warnings">
          <p [innerHTML]="textkeyPrefix + '.step.warning.' + formWarning | translate"></p>
        </div>
      }

      <div formfield [invalidIfEmpty]="false" [inlineHelp]="true" [showInlineHelp]="showInlineHelp" [form]="form" [formModel]="formFields.flaeche_verfuegbar" [formConfig]="formConfig" [step]="textkeyPrefix" class="formfield {{formFields.flaeche_verfuegbar.type}} {{formFields.flaeche_verfuegbar.classes}}"></div>

      @if (field === 'flaeche_verfuegbar' && showSwitch === true) {
        <div class="switch-wrapper callout" aria-hidden="true">
          <p [innerHTML]="textkeyPrefix + '.switch.teaser' | translate"></p>
          <button type="button" class="toggle" tabindex="-1" (click)="setField('flaeche_karte')" [innerHTML]="textkeyPrefix + '.switch.link'  | translate"></button>
        </div>
      }

      @if (field !== 'flaeche_verfuegbar') {
        <div class="mode-wrapper">
          <div class="grid-x">
            @for (mode of ['karte', 'wohnflaeche']; track mode) {
              <div class="cell auto">
                <input type="radio" [id]="'mode_' + mode" name="mode" [value]="mode" [checked]="field === 'flaeche_' + mode" (change)="setField('flaeche_' + mode)">
                <label [for]="'mode_' + mode" [innerHTML]="(textkeyPrefix + '.mode.' + mode) | translate"></label>
              </div>
            }
            <div class="cell shrink">
              <button type="button" class="close" [attr.aria-expanded]="!form.controls['flaeche_verfuegbar']?.disabled" aria-controls="flaeche_verfuegbar flaeche_karte flaeche_wohnflaeche" [attr.aria-label]="'arialabel.close' | translate" (click)="setField('flaeche_verfuegbar')" [title]="(textkeyPrefix + '.switch.close') | translate">
                <i class="icon-x"></i>
              </button>
            </div>
          </div>
        </div>
      }

      @if (field === 'flaeche_karte') {
        <div class="map-wrapper">
          <div class="search-wrapper" [class.loading]="mapLoading" [class.error]="formError === 'empty_address'">
            <input type="text" (keydown.enter)="locateAddress($event)" autocomplete="street-address" name="address" [attr.aria-label]="textkeyPrefix + '.map.search.placeholder' | translate" formControlName="address" [placeholder]="textkeyPrefix + '.map.search.placeholder' | translate" required>
            @if (mapLoading === false) {
              <button (click)="locateAddress($event)" [title]="textkeyPrefix + '.map.search.button.title' | translate"><i class="icon-co2_linkicon_bold"></i></button>
            }
            @if (searchError) {
              <p [innerHTML]="(textkeyPrefix + '.map.search.error.' + searchError) | translate"></p>
            }
          </div>
          <div class="map-container-wrapper">
            <div id="map" class="map-container"></div>
            @if (mapHintText) {
              <div class="hint">
                <p [innerHTML]="(textkeyPrefix + '.map.hint.' + mapHintText) | translate"></p>
                <button class="close" [title]="textkeyPrefix + '.map.hint.close' | translate" (click)="mapHintText = null"><i class="icon-x"></i></button>
              </div>
            }
          </div>
        </div>
      }

      @if (field === 'flaeche_wohnflaeche') {
        <div class="area-wrapper">
          <div class="grid-x grid-margin-x">
            <div class="cell small-12 medium-6">
              <div formfield [invalidIfEmpty]="false" [inlineHelp]="true" [showInlineHelp]="showInlineHelp" [form]="form" [formModel]="formFields.wohnflaeche" [formConfig]="formConfig" [step]="textkeyPrefix" class="formfield {{formFields.wohnflaeche.type}} {{formFields.wohnflaeche.classes}}"></div>
            </div>
            <div class="cell small-12 medium-6">
              <div formfield [invalidIfEmpty]="false" [inlineHelp]="true" [showInlineHelp]="showInlineHelp" [form]="form" [formModel]="formFields.stockwerke" [formConfig]="formConfig" [step]="textkeyPrefix" class="formfield {{formFields.stockwerke.type}} {{formFields.stockwerke.classes}}"></div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  <app-step-buttons [nextClass]="loading? 'loading' : ''" [previousLink]="previousStep? previousStep.path : null" [nextLink]="steps?.nextStep? steps.nextStep.path : null" [nextDisabled]="!form.valid" (onNextClick)="submitClicked()"></app-step-buttons>
</form>

